export default __webpack_public_path__ + "static/media/NTORQ 125_2.23e4af8a.webp";